/**
 * O interruptor da paleta de busca (Story 18.1, AC-5).
 *
 * Zustand em singleton de módulo, o mesmo padrão de
 * `stores/background-upload-store.ts`: um `create()` simples é um objeto ao
 * nível do módulo, que o React Router nunca desmonta — por isso não foi preciso
 * acrescentar um Context nem um Provider ao `App.tsx` para que o atalho do
 * `AppLayout` e o gatilho do trilho falem do MESMO estado.
 *
 * Só o interruptor vive aqui. O termo digitado, o escopo e o índice do teclado
 * ficam dentro do diálogo, e é deliberado: fechar a paleta deve esquecer o que
 * lá estava. Guardá-los aqui faria a próxima abertura herdar uma busca velha —
 * e o gesto `⌘K` é "quero procurar agora", não "quero voltar ao que procurei".
 */
import { create } from 'zustand'

export interface GlobalSearchState {
  isOpen: boolean
  open: () => void
  close: () => void
  toggle: () => void
}

export const useGlobalSearchStore = create<GlobalSearchState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}))
